export async function getLocation() {
  return new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(
      (...args) => resolve(...args),
      (...args) => reject(...args)
    )
  );
}
